import { cpfMask, cnpjMask, telefoneMask, cepMask, dateMask } from 'luxFw/transformations/Mascaras';
import { preparaListaParaCombo } from 'luxFw/transformations/Common';
import {
  INICIA_CATEGORIA,
  NOVO_CATEGORIA,
  BUSCA_CATEGORIA_EDICAO,
  CANCELA_EDICAO,
  INICIO_CATEGORIA_SUCESSO,
  SALVA_CATEGORIA_SUCESSO,
  REMOVE_CATEGORIA_SUCESSO,
  BUSCA_CATEGORIA_EDICAO_SUCESSO,
  INIT_URL,
  HIDE_MESSAGE,
  ON_HIDE_LOADER,
  ON_SHOW_LOADER,
  ON_SHOW_ERROR_MESSAGE,
  SHOW_MESSAGE,
  ALTERACAO_CAMPO,
  ALTERACAO_COMBO,
  ALTERACAO_DATEPICKER,
  ALTERACAO_CHECK,
  ALTERACAO_CAMPO_MASCARA_CEP,
  ALTERACAO_CAMPO_MASCARA_CNPJ,
  ALTERACAO_CAMPO_MASCARA_CPF,
  ALTERACAO_CAMPO_MASCARA_DATE,
  ALTERACAO_CAMPO_MASCARA_TELEFONE,
  LIMPAR_CATEGORIA,
  LISTA_CATEGORIA_SUCESSO,
  LISTA_CATEGORIA,
  INICIO_CENARIO_CATEGORIA_LOCAL,
  INICIO_CENARIO_CATEGORIA_LOCAL_SUCESSO,
  APLICA_FILTRO
} from "constants/ActionTypes";

const INIT_STATE = {

  // Configuração da Grid
  colunasGrid: [
    { titulo: 'Codigo Categoria', propriedadeApi: 'id', alinhamento: 'left', chave: true, numerico: true },
    { titulo: 'Curso', propriedadeApi: 'descricaoGrupoCategoria', alinhamento: 'left' },
    { titulo: 'Categoria', propriedadeApi: 'descricaoUnidadeCategoria', alinhamento: 'left' },
  ],

  // Propriedades Globais
  loader: false,
  alertMessage: '',
  showMessageSuccess: false,
  showMessageError: false,
  edicao: false,
  carregandoLista: true,
  listGrid: [],
  listGridComFiltro: [],
  rotuloGrupoCategoria: '',
  rotuloUnidadeCategoria: '',
  textoFiltro: '',

  listaLocaisCompleta: [],

  // Campos do Formulario
  id: 0,
  descricaoGrupoCategoria: '',
  descricaoUnidadeCategoria: '',
  idLocalControladoFixado: 0,
  nomeLocalControladoFixado: '',  

  // Combos
  listaDeLocaisControlados: [],
  listaDeLocaisControladosGeral: [],

  // Filtros
  modeloFiltro: '',
  numeroFiltro: '',
  situacaoFiltro: '',
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case INICIA_CATEGORIA: {
      return {
        ...state,
        edicao: false,
        loader: true,
        carregandoLista: true,
        textoFiltro: '',
      }
    }
    case NOVO_CATEGORIA: {
      return {
        ...state,
        edicao: true,
        id: 0,
        descricaoGrupoCategoria: '',
        descricaoUnidadeCategoria: '',
      }
    }
    case APLICA_FILTRO: {

      const filtroAplicar = action.payload;
      var listaFiltrada = filtroAplicar.length >= 3 ? state.listGrid.filter(x => x.descricaoGrupoCategoria.toLowerCase().includes(filtroAplicar.toLowerCase()) || x.descricaoUnidadeCategoria.toLowerCase().includes(filtroAplicar.toLowerCase())) : [];

      return {
        ...state,
        textoFiltro: filtroAplicar,
        listGridComFiltro: filtroAplicar.length >= 3 ? listaFiltrada : state.listGridComFiltro
      }
    }      
    case BUSCA_CATEGORIA_EDICAO: {
      return {
        ...state,
        loader: true,
      }
    }
    case CANCELA_EDICAO: {
      return {
        ...state,
        edicao: false,
        textoFiltro: '',
      }
    }
    case INICIO_CATEGORIA_SUCESSO: {

      const retorno = action.payload;
      var locaisCompleto = retorno.locaisControlados.filter(x => x.descricaoRotuloGrupoCategoria !== '' && x.descricaoRotuloUnidadeCategoria !== '');
      var locaisCombo = retorno.locaisControlados.filter(x => x.descricaoRotuloGrupoCategoria !== '' && x.descricaoRotuloUnidadeCategoria !== '');

      return {
        ...state,
        loader: false,
        carregandoLista: false,
        listaLocaisCompleta: locaisCompleto,
        idLocalControladoFixado: 0,
        listaDeLocaisControladosGeral: retorno.locaisControlados,
        listaDeLocaisControlados: preparaListaParaCombo(locaisCombo, "id", "descricaoLocalControlado"),
      }
    }
    case INICIO_CENARIO_CATEGORIA_LOCAL: {
      const retorno = action.payload;

      return {
        ...state,
        idLocalControladoFixado: retorno.idLocal,
        carregandoLista: true,
        loader: true,
      }
    }
    case INICIO_CENARIO_CATEGORIA_LOCAL_SUCESSO: {
      const retorno = action.payload;

      if (retorno.idLocal !== 0) {
        var localControlado = retorno.locaisControlados === null ? state.listaLocaisCompleta.filter(x => x.id === retorno.idLocal) : retorno.locaisControlados.filter(x => x.id === retorno.idLocal);
        state.rotuloGrupoCategoria = localControlado[0].descricaoRotuloGrupoCategoria;
        state.rotuloUnidadeCategoria = localControlado[0].descricaoRotuloUnidadeCategoria;
        state.nomeLocalControladoFixado = localControlado[0].descricaoLocalControlado;
      }

      let data = [...state.colunasGrid],
        indexGrupo = data.findIndex(r => r.propriedadeApi === "descricaoGrupoCategoria"),
        indexUnidade = data.findIndex(r => r.propriedadeApi === "descricaoUnidadeCategoria")

      data[indexGrupo].titulo = state.rotuloGrupoCategoria;
      data[indexUnidade].titulo = state.rotuloUnidadeCategoria;

      return {
        ...state,
        loader: false,
        carregandoLista: false,
        idLocalControladoFixado: retorno.idLocal,
        nomeLocalControladoFixado: state.nomeLocalControladoFixado,
        colunasGrid: data,
        listGrid: retorno.categorias,
        listaLocaisCompleta: retorno.locaisControlados === null ? state.listaLocaisCompleta.filter(x => x.descricaoRotuloGrupoCategoria !== '' && x.descricaoRotuloUnidadeCategoria !== '') : retorno.locaisControlados.filter(x => x.descricaoRotuloGrupoCategoria !== '' && x.descricaoRotuloUnidadeCategoria !== ''),
        listaDeLocaisControlados: retorno.locaisControlados === null ? state.listaDeLocaisControlados.filter(x => x.descricaoRotuloGrupoCategoria !== '' && x.descricaoRotuloUnidadeCategoria !== '') : preparaListaParaCombo(retorno.locaisControlados.filter(x => x.descricaoRotuloGrupoCategoria !== '' && x.descricaoRotuloUnidadeCategoria !== ''), "id", "descricaoLocalControlado")        
      }
    }

    case SALVA_CATEGORIA_SUCESSO: {
      return {
        ...state,
        loader: false,
        alertMessage: action.payload,
        showMessageSuccess: true,
        edicao: false,
        idLocalControladoFixado: state.idLocalControladoFixado
      }
    }
    case REMOVE_CATEGORIA_SUCESSO: {
      return {
        ...state,
        loader: false,
        alertMessage: action.payload,
        showMessageSuccess: true,
        edicao: false
      }
    }
    case LISTA_CATEGORIA: {
      const retorno = action.payload;

      return {
        ...state,
        loader: true,
      }
    }
    case LISTA_CATEGORIA_SUCESSO: {
      const retorno = action.payload;

      return {
        ...state,
        loader: false,
        listGrid: retorno.categoria,
      }
    }
    case LIMPAR_CATEGORIA: {

      var retorno = action.payload;

      return {
        ...state,
        modeloFiltro: '',
        numeroFiltro: '',
        situacaoFiltro: '',
      }
    }
    case BUSCA_CATEGORIA_EDICAO_SUCESSO: {
      var retorno = action.payload;

      return {
        ...state,
        edicao: true,
        loader: false,

        id: retorno.id,
        descricaoGrupoCategoria: retorno.descricaoGrupoCategoria,
        descricaoUnidadeCategoria: retorno.descricaoUnidadeCategoria,
        alertMessage: '',
        showMessageSuccess: false,
        showMessageError: false,
      }
    }
    case INIT_URL: {
      return {
        ...state,
        initURL: action.payload
      }
    }
    case HIDE_MESSAGE: {
      return {
        ...state,
        alertMessage: '',
        showMessageSuccess: false,
        showMessageError: false,
        loader: false
      }
    }
    case ON_HIDE_LOADER: {
      return {
        ...state,
        loader: false
      }
    }
    case ON_SHOW_LOADER: {
      return {
        ...state,
        loader: true
      }
    }
    case ON_SHOW_ERROR_MESSAGE: {
      return {
        ...state,
        loader: false,
        alertMessage: action.payload,
        showMessageError: true,
        edicao: false
      }
    }
    case SHOW_MESSAGE: {
      return {
        ...state,
        alertMessage: action.payload,
        showMessageError: true,
        loader: false
      }
    }
    case ALTERACAO_CAMPO: {
      return {
        ...state,
        [action.payload.target.name]: action.payload.target.value,
      }
    }
    case ALTERACAO_COMBO: {
      return {
        ...state,
        [action.payload.nomeCombo]: action.payload.valor,
      }
    }
    case ALTERACAO_DATEPICKER: {
      return {
        ...state,
        [action.payload.name]: action.payload.date,
      }
    }
    case ALTERACAO_CHECK: {
      return {
        ...state,
        [action.payload.nomeCheck]: action.payload.valor,
      }
    }
    case ALTERACAO_CAMPO_MASCARA_CPF: {
      return {
        ...state,
        [action.payload.target.name]: cpfMask(action.payload.target.value)
      }
    }
    case ALTERACAO_CAMPO_MASCARA_CNPJ: {
      return {
        ...state,
        [action.payload.target.name]: cnpjMask(action.payload.target.value)
      }
    }
    case ALTERACAO_CAMPO_MASCARA_TELEFONE: {
      return {
        ...state,
        [action.payload.target.name]: telefoneMask(action.payload.target.value)
      }
    }
    case ALTERACAO_CAMPO_MASCARA_CEP: {
      return {
        ...state,
        [action.payload.target.name]: cepMask(action.payload.target.value)
      }
    }
    case ALTERACAO_CAMPO_MASCARA_DATE: {
      return {
        ...state,
        [action.payload.target.name]: dateMask(action.payload.target.value),

      }
    }
    default:
      return state;
  }
}
